<template>
  <div class="wrapGridArea">
    <div class="title">한 화면에 3개의 SBGrid를 테스트 <span style="font-size:12px; color: #aaa; font-style: italic;">그리드 간 연동을 통하여 더 많은 기능 구현이 가능합니다.</span></div>
    <SBGrid
      id="grid"
      class="grids"
      style="width: 5%; height: 300px; margin-right:20px;"
      ref="grid"
      :data="ct_data_page1"
      :columns="grid1columns"
      :gridattr="{fixedrowheight:'0'}"
      :bind="{click: 'fnClickFirstGrid'}"
    ></SBGrid>
    <SBGrid
      id="grid2"
      class="grids"
      style="width: 30%; height: 300px; margin-right:20px;"
      ref="grid2"
      :data="ct_data_page1_2"
      :columns="grid2columns"
      :gridattr="{fixedrowheight:'0'}"
      :bind="{click: 'fnClickSecondGrid'}"
    ></SBGrid>
    <SBGrid
      id="grid3"
      class="grids"
      style="width: 40%; height: 300px;"
      ref="grid3"
      :data="temp_Group_data"
      :columns="grid3columns"
      :gridattr="{fixedrowheight:'0', extendlastcol: 'scroll',}"
      :bind="{click: 'fnClickThirdGrid'}"
    ></SBGrid>

    <div id="contbox">
      <span id="subText">선택상품</span> <input id="secondProduct" type="text" disabled><input id="thirdProduct" type="text" disabled>
    </div>
  </div>
</template>

<script>
import SBGrid from "../SBGrid.vue"
var grid1columns = [{"caption": [""],"ref": "col1","width": "100%","style": "text-align:center","type": "output"}];
var grid2columns = [{"caption": [""],"ref": "col1","width": "100%","style": "text-align:center","type": "output"}];
var grid3columns = [
  { "caption": ['lv'], "ref": 'lv', "width": "100px", "type": 'output', hidden: true },
  { "caption": ['코드명'], "ref": 'codeName', "width": "250px", "type": 'output' },
  { "caption": ['데이터'], "ref": 'sale', "width": "108px", "type": 'output', style: "text-align:right;", format: "#,##0" }
];

window.fnClickFirstGrid = function() {
  switch (window.vl.$refs.view.$refs.grid.gridObject.getCellData(window.vl.$refs.view.$refs.grid.gridObject.getRow(),0)) {
    case "주력" : 
      ct_data_page1_2 = ct_data_page1_3;
      break;
    case "상해" : 
      ct_data_page1_2 = ct_data_page1_4;
      break;
    case "운전자" : 
      ct_data_page1_2 = ct_data_page1_5;
      break;
    case "질병" : 
      ct_data_page1_2 = ct_data_page1_6;
      break;
    case "실손연계" : 
      ct_data_page1_2 = ct_data_page1_7;
      break;
    default: 
      ct_data_page1_2 = ct_data_page1_3;
      break;
  }
  window.vl.$refs.view.$refs.grid2.gridObject.setGridData(ct_data_page1_2, true);
}
window.fnClickSecondGrid = function() {
  switch(window.vl.$refs.view.$refs.grid2.gridObject.getRow()) {
    case 1:
      temp_Group_data = group_Data1;
      break;
    case 2:
      temp_Group_data = group_Data2;
      break;
    case 3:
      temp_Group_data = group_Data3;
      break;
    default :
      temp_Group_data = group_Data1;
      break;
  }
  window.vl.$refs.view.$refs.grid3.gridObject.setGridData(temp_Group_data, true);
  window.vl.$refs.view.$refs.grid3.gridObject.setGroup({
    type: 'custom', //every 하나의 열에 각 level을 접고 펼치는 UI를 모두 표시,
    /*each:level별로 각각의 열에 접교 펼치는 UI 제공, custom : 특정 level값을 데이터에 저장하여 해당 값을 가지고 그룹 적용*/

    typeinfo: { // 그리드 그룹 type 속성별로 종속 속성 설정
        levelcolid: window.vl.$refs.view.$refs.grid3.gridObject.getColID(window.vl.$refs.view.$refs.grid3.gridObject.getColRef('lv')) //custom 설정시 특정 level 값을 저장하는 열에 아이디 지정
    },

    columns: [ //each, every, 설정시 레벨 열 설정
        {
            colid: window.vl.$refs.view.$refs.grid3.gridObject.getColID(window.vl.$refs.view.$refs.grid3.gridObject.getColRef('codeName')), //레벨 열의 열 아이디 설정
            open: false // 그룹화 후 그룹 오픈 여부 설정
        }
    ]
  }, false);
  document.querySelector('#secondProduct').value = window.vl.$refs.view.$refs.grid2.gridObject.getCellData(window.vl.$refs.view.$refs.grid2.gridObject.getRow(),0)
}
window.fnClickThirdGrid = function() {
  document.querySelector('#thirdProduct').value = window.vl.$refs.view.$refs.grid3.gridObject.getCellData(window.vl.$refs.view.$refs.grid3.gridObject.getRow(),1)
}
export default {
  mounted: function(){
    this.$nextTick(function() {
      window.vl.$refs.view.$refs.grid.gridObject.clickRow(1)
      window.vl.$refs.view.$refs.grid2.gridObject.clickRow(1)
    })
  },
  data: function() {
    return {
      ct_data_page1_2 : ct_data_page1_2,
      temp_Group_data : temp_Group_data,
      grid1columns,
      grid2columns,
      grid3columns,
      autoCompleteData,
      ct_data_page1,
      group_Data1,
      group_Data2,
      group_Data3,
      ct_data_page1_3,
      ct_data_page1_4,
      ct_data_page1_5,
      ct_data_page1_6,
      ct_data_page1_7,
    }
  },
  components: {
    SBGrid
  },
}


var autoCompleteData = [
  "파워라이트 통합보험(1901) 1종", "파워라이트 통합보험(1901) 2종", "착한가격 간편치매보험(일반심사 일반행)", "착한가격 간편치매보험(일반심사 해지환급금 미지급행)",
    "든든한 SMILE 운전자보험(1901)_1종(년만기)", "든든한 SMILE 운전자보험(1901)_2종(세만기)"
];
var ct_data_page1 = [{"col1":"주력"},{"col1":"상해"},{"col1":"운전자"},{"col1":"질병"},{"col1":"실손연계"}];
var temp_Group_data = [];
var group_Data1 = [{"codeName":"암 무서류 플랜(20~60세), 남/여","lv":1},{"codeName":"일반상해사망","sale":"50000","lv":2},{"codeName":"암사망","sale":"20000","lv":2},{"codeName":"암진단비(유사암제외)","sale":"3000","lv":2},{"codeName":"암진단비(소액암 및 유사암제외)","sale":"3000","lv":2},{"codeName":"유사암진단비","sale":"900","lv":2},{"codeName":"의료비 플랜(40~60세), 남/여","lv":1},{"codeName":"일반상해사망","sale":"50000","lv":2},{"codeName":"암사망","sale":"20000","lv":2},{"codeName":"암진단비(유사암제외)","sale":"3000","lv":2},{"codeName":"암진단비(소액암 및 유사암제외)","sale":"3000","lv":2},{"codeName":"유사암진단비","sale":"900","lv":2},{"codeName":"수술비 플랜(40~60세), 남/여","lv":1},{"codeName":"일반상해사망","sale":"50000","lv":2},{"codeName":"암사망","sale":"20000","lv":2},{"codeName":"암진단비(유사암제외)","sale":"3000","lv":2},{"codeName":"암진단비(소액암 및 유사암제외)","sale":"3000","lv":2},{"codeName":"유사암진단비","sale":"900","lv":2},{"codeName":"당뇨 플랜(40~60세), 남/여","lv":1},{"codeName":"일반상해사망","sale":"50000","lv":2},{"codeName":"암사망","sale":"20000","lv":2},{"codeName":"암진단비(유사암제외)","sale":"3000","lv":2},{"codeName":"암진단비(소액암 및 유사암제외)","sale":"3000","lv":2},{"codeName":"유사암진단비","sale":"900","lv":2}];
var group_Data2 = [{"codeName":"당뇨 플랜(40~60세), 남/여","lv":1},{"codeName":"일반상해사망","sale":"50000","lv":2},{"codeName":"암사망","sale":"20000","lv":2},{"codeName":"암진단비(유사암제외)","sale":"3000","lv":2},{"codeName":"암진단비(소액암 및 유사암제외)","sale":"3000","lv":2},{"codeName":"유사암진단비","sale":"900","lv":2}];
var group_Data3 = [ {"codeName":"의료비 플랜(40~60세), 남/여","lv":1},{"codeName":"일반상해사망","sale":"50000","lv":2},{"codeName":"암사망","sale":"20000","lv":2},{"codeName":"암진단비(유사암제외)","sale":"3000","lv":2},{"codeName":"암진단비(소액암 및 유사암제외)","sale":"3000","lv":2},{"codeName":"유사암진단비","sale":"900","lv":2},{"codeName":"수술비 플랜(40~60세), 남/여","lv":1},{"codeName":"일반상해사망","sale":"50000","lv":2},{"codeName":"암사망","sale":"20000","lv":2},{"codeName":"암진단비(유사암제외)","sale":"3000","lv":2},{"codeName":"암진단비(소액암 및 유사암제외)","sale":"3000","lv":2},{"codeName":"유사암진단비","sale":"900","lv":2}];    
var ct_data_page1_2;
//주력
var ct_data_page1_3 = [{"col1":"파워라이트 통합보험(1901) 1종"},{"col1":"파워라이트 통합보험(1901) 2종"},{"col1":"착한가격 간편치매보험(일반심사 일반행)"},{"col1":"착한가격 간편치매보험(일반심사 해지환급금 미지급행)"},{"col1":"든든한 SMILE 운전자보험(1901)_1종(년만기)"},{"col1":"든든한 SMILE 운전자보험(1901)_2종(세만기)"},{"col1":"착한가격 간편치매보험(일반심사 일반행)"},{"col1":"착한가격 간편치매보험(일반심사 해지환급금 미지급행)"},{"col1":"든든한 SMILE 운전자보험(1901)_1종(년만기)"},{"col1":"든든한 SMILE 운전자보험(1901)_2종(세만기)"}];
//전체
var ct_data_page1_4 = [{"col1": "무배당 행복한 인생 재산지킴이보험"},{"col1": "무배당 행복든든종합보험(1307)"},{"col1": "무배당 행복을 多주는 우리집종합보험(1307)"},{"col1": "무배당 행복재산 종합보험(1307)"},{"col1": "무배당 행복을 多주는 우리집종합보험(1402)"},{"col1": "무배당 행복을 多주는 우리집종합보험(1408)"},{"col1": "무배당 행복을 多주는 우리집종합보험(1501)"},{"col1": "무배당 행복을 多주는 우리집종합보험(1507)"},{"col1": "무배당 행복을 多주는 우리집종합보험(1601)"},{"col1": "무배당 행복을 多주는 우리집종합보험(1604)"},{"col1": "무배당 행복을 多주는 우리집종합보험(1307)"},{"col1": "무배당 흥국화재 화재배상책임보험"},{"col1": "무배당 행복재산종합보험(1404)1종"},{"col1": "무배당 행복재산종합보험(1404)2종"},{"col1": "무배당 행복든든종합보험(1404)1종"},{"col1": "무배당 행복든든종합보험(1404)2종"},{"col1": "무배당 흥국화재 화재배상책임보험(1404)"}]
// 상해
var ct_data_page1_5 = [{"col1": "무배당 든든한 명품상해보험FC"},{"col1": "무배당 든든한 명품상해보험AM"},{"col1": "무배당 명품상해보험(1601)_FC"},{"col1": "무배당 명품상해보험(1601)_AM"},{"col1": "무배당 실속있는 상해보험(1종)"},{"col1": "무배당 실속있는 상해보험(2종)"},{"col1": "무배당 실속있는 상해보험(1701)(1종)"},{"col1": "무배당 실속있는 상해보험(1701)(2종)"},{"col1": "무배당 NEW 실속있는 상해보험"},{"col1": "무배당 NEW 실속있는 상해보험(1708)1종"},{"col1": "무배당 NEW 실속있는 상해보험(1708)2종"},{"col1": "무배당 NEW 실속있는 상해보험(1801)1종"},{"col1": "무배당 NEW 실속있는 상해보험(1801)2종"},{"col1": "무배당 일석이조(一石二鳥) 명품상해보험(1604)"},{"col1": "무배당 일석이조(一石二鳥) 명품상해보험"},{"col1": "무배당 일석이조(一石二鳥) 명품상해보험(1604)"},{"col1": "무배당 일석이조(一石二鳥) 상해보험(세만기)"},{"col1": "무배당 일석이조(一石二鳥) 상해보험(연만기)"},{"col1": "무배당 일석이조(一石二鳥) 상해보험(1701)(세만기)"},{"col1": "무배당 일석이조(一石二鳥) 상해보험(1701)(연만기)"},{"col1": "무배당 New 일석이조(一石二鳥) 상해보험(세만기)"},{"col1": "무배당 New 일석이조(一石二鳥) 상해보험(연만기)"},{"col1": "무배당 New 일석이조(一石二鳥) 상해보험(1708)(세만기)"},{"col1": "무배당 New 일석이조(一石二鳥) 상해보험(1708)(연만기)"},{"col1": "무배당 New 일석이조(一石二鳥) 상해보험(1801)(세만기)"},{"col1": "무배당 New 일석이조(一石二鳥) 상해보험(1801)(연만기)"}];
var ct_data_page1_6 =[{"col1": "무배당 스페셜운전자저축보험(1404)"},{"col1": "무배당 스페셜운전자저축보험(1405)"},{"col1": "무배당 행복을 多주는 운전자보험(1210)"},{"col1": "무배당 행복을 多주는 운전자보험(1408)FC"},{"col1": "무배당 행복을 多주는 운전자보험(1408)AM"},{"col1": "무배당 든든한 붕붕붕 명품 운전자보험(1503)"},{"col1": "무배당 붕붕붕 운전자보험(1507)(1종)"},{"col1": "무배당 붕붕붕 운전자보험(1507)(2종)"},{"col1": "무배당 든든한 붕붕붕 운전자보험(1507)(1종)FC"},{"col1": "무배당 든든한 붕붕붕 운전자보험(1507)(2종)FC"},{"col1": "무배당 든든한 붕붕붕 운전자보험(1507)(1종)AM"},{"col1": "무배당 든든한 붕붕붕 운전자보험(1507)(2종)AM"},{"col1": "무배당 든든한 붕붕붕 lady 운전자보험(1507)(1종)"},{"col1": "무배당 든든한 붕붕붕 lady 운전자보험(1507)(2종)"},{"col1": "무배당 든든한 붕붕붕 운전자보험(1510)(1종)FC"},{"col1": "무배당 든든한 붕붕붕 운전자보험(1510)(2종)FC"},{"col1": "무배당 든든한 붕붕붕 운전자보험(1510)(1종)AM"},{"col1": "무배당 든든한 붕붕붕 운전자보험(1510)(2종)AM"},{"col1": "무배당 든든한 붕붕붕 운전자보험(1601)_FC"},{"col1": "무배당 든든한 붕붕붕 운전자보험(1601)_AM"},{"col1": "무배당 든든한 SMILE 운전자보험"},{"col1": "무배당 든든한 붕붕붕 운전자보험(1604)_FC"},{"col1": "무배당 든든한 붕붕붕 운전자보험(1604)_AM"},{"col1": "무배당 붕붕붕 운전자보험(1604)"},{"col1": "무배당 든든한 SMILE 운전자보험(1606)"},{"col1": "무배당 프리미엄행복 운전자보험"},{"col1": "무배당 든든한 SMILE 운전자보험II"},{"col1": "무배당 든든한 SMILE 운전자보험(1701)"},{"col1": "무배당 NEW SMILE 운전자보험"},{"col1": "무배당 든든한 SMILE 운전자보험(1704)"},{"col1": "무배당 든든한 SMILE 운전자보험(1708)"},{"col1": "무배당 든든한 SMILE 운전자보험(1801)"},{"col1": "무배당 드라이브안심운전자보험(0804)"}];
//질병 실손연계
var ct_data_page1_7 = [{"col1": "무배당 흥국화재 실손의료보험(범용_1304)_1~2종"},{"col1": "무배당 흥국화재 실손의료보험(범용_1404)_1~2종"},{"col1": "무배당 흥국화재 실손의료보험(범용_1501)_1~2종"},{"col1": "무배당 흥국화재 실손의료보험(범용_1509)_1~2종"},{"col1": "무배당 흥국화재 실손의료보험(범용_1601)_1~2종"},{"col1": "무배당 흥국화재 실손의료보험(추가용_1602)_1~2종"},{"col1": "무배당 흥국화재 실손의료보험(범용_1604)_1~2종"},{"col1": "무배당 흥국화재 실손의료보험(추가용_1604)_1~2종"},{"col1": "무배당 흥국화재 실손의료보험(계약전환용)(갱신형)_1~3종"},{"col1": "무배당 흥국화재 실손의료보험(추가용_1701)_1~2종"},{"col1": "무배당 흥국화재 실손의료보험(범용_1701)_1~2종"},{"col1": "무배당 흥국화재 실손의료보험(계약전환용)(1701)(갱신형)_1~3종"},{"col1": "무배당 흥국화재 실손의료보험(추가용_1704)_1~2종"},{"col1": "무배당 흥국화재 실손의료보험(범용_1704)_1~2종"},{"col1": "무배당 흥국화재 실손의료보험(계약전환용_1704)(갱신형)1종"},{"col1": "무배당 흥국화재 실손의료보험(계약전환용_1704)(갱신형)2종"},{"col1": "무배당 흥국화재 실손의료보험(계약전환용_1704)(갱신형)3종"},{"col1": "무배당 흥국화재 다이렉트 실손의료보험"},{"col1": "무배당 흥국화재 실손의료보험(추가용_1708)_1~2종"},{"col1": "무배당 흥국화재 실손의료보험(범용_1708)_1~2종"},{"col1": "무배당 실손의료비(기본납입형_1708)특별약관"},{"col1": "무배당 흥국화재 실손의료보험(계약전환용_1708)(갱신형)1종"},{"col1": "무배당 흥국화재 실손의료보험(계약전환용_1708)(갱신형)2종"},{"col1": "무배당 흥국화재 실손의료보험(계약전환용_1708)(갱신형)3종"},{"col1": "무배당 흥국화재 다이렉트 실손의료보험(1708)"},{"col1": "무배당 흥국화재 실손의료보험(추가용_1704)_1~2종"},{"col1": "무배당 흥국화재 실손의료보험(범용_1704)_1~2종"},{"col1": "무배당 실손의료비(기본납입형_1704)특별약관"},{"col1": "무배당 흥국화재 실손의료보험(계약전환용_1704)(갱신형)"},{"col1": "무배당 3대질병 집중보장보험"}];
</script>

<style scoped>
#subText {
  margin-top: 20px;
  margin-right: 15px;
  width: 5%;
  padding: 5px;
  display: inline-block;
  text-align: center;
  vertical-align: bottom;
}
#subText,#secondProduct,#thirdProduct { 
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 12px;
  height: 33px;
}
#contbox input {
  width: 25%;
  height: 33px;
  margin-right: 5px;
  text-align: center;
  transition: 0.3s all;
  background: none;
}
#contbox input:hover {
  outline: none !important; border-color: #8bdeb8; box-shadow: 0 0 10px #ccf7e4;
}

</style>